module.exports = __webpack_public_path__ + "media/virtualStagingSlider/virtualStagingSlider8Post-b939957f.jpeg";